export const currentStatus = (state) => state.status;
export const currentUser = (state) => state.usuario;
export const currentToken = (state) => state.token;
